module.exports = __webpack_public_path__ + "media/assets/Reports-d6df74e0bbe54f0fbafbeac6a72a488a.svg";